module.exports = __webpack_public_path__ + "static/media/icon-7.126cba61.png";